import { useEffect, useState } from 'react';

let interval: ReturnType<typeof setTimeout> = null;
const updaters = new Set<() => void>();

function startInterval() {
    if (!interval) {
        interval = setInterval(() => {
            updaters.forEach(updater => {
                updater();
            });
        }, 1000);
    }
}

function stopInterval() {
    if (interval) {
        clearInterval(interval);
        interval = null;
    }
}

const increaseOrDecrease = (seconds, timestamp, clockStopped, countDown) => {
    if (clockStopped || seconds == null) {
        return seconds || 0;
    }
    return Math.max(0, seconds + (countDown ? -1 : 1) * Math.floor((Date.now() - timestamp) / 1000));
};

const useMatchTimer = (matchSeconds: number, timestamp: number, clockStopped: boolean, countDown: boolean) => {
    const [currentSeconds, setCurrentSeconds] = useState(
        increaseOrDecrease(matchSeconds, timestamp, clockStopped, countDown)
    );
    useEffect(() => {
        if (!interval) {
            startInterval();
        }

        function update() {
            if (matchSeconds != null) {
                setCurrentSeconds(increaseOrDecrease(matchSeconds, timestamp, clockStopped, countDown));
            }
        }

        updaters.add(update);

        return () => {
            updaters.delete(update);
            if (updaters.size === 0) {
                stopInterval();
            }
        };
    }, [matchSeconds, timestamp, countDown, clockStopped]);

    return currentSeconds;
};

export default useMatchTimer;
